import { Rocket } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0b1121] text-white/60 py-14 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="grid place-items-center w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500 to-fuchsia-600 shadow-lg shadow-purple-500/30">
              <Rocket className="w-5 h-5 text-white" />
            </span>
            <span className="font-display text-white text-xl font-extrabold">
              ROCKET<span className="text-purple-300">CAP</span> FUNDING
            </span>
          </div>
          <p className="text-sm max-w-md leading-relaxed">
            Fast, flexible capital for real growth. Serving businesses and
            entrepreneurs in all 50 U.S. states.
          </p>
          <p className="mt-6 text-xs uppercase tracking-widest text-white/40">
            © {new Date().getFullYear()} Rocket Cap Funding. All rights reserved.
          </p>
        </div>

        <div>
          <h4 className="font-display text-white font-bold mb-4 text-sm uppercase tracking-widest">
            Company
          </h4>
          <ul className="space-y-2 text-sm">
            <li><a href="#about" className="hover:text-white transition">About</a></li>
            <li><a href="#how-we-work" className="hover:text-white transition">How we work</a></li>
            <li><a href="#testimonials" className="hover:text-white transition">Testimonials</a></li>
            <li><a href="#contact" className="hover:text-white transition">Contact</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-white font-bold mb-4 text-sm uppercase tracking-widest">
            Products
          </h4>
          <ul className="space-y-2 text-sm">
            <li><a href="#services" className="hover:text-white transition">Working Capital</a></li>
            <li><a href="#services" className="hover:text-white transition">SBA Loans</a></li>
            <li><a href="#services" className="hover:text-white transition">Business Lines of Credit</a></li>
            <li><a href="#credit-repair" className="hover:text-white transition">Credit Repair</a></li>
          </ul>
        </div>
      </div>

      <p className="max-w-7xl mx-auto px-6 lg:px-10 mt-10 text-xs text-white/30 leading-relaxed">
        Rocket Cap Funding is a marketing site for a small business financing
        broker. Not a bank. Loan products and terms are subject to underwriting
        and lender approval. Estimates shown are illustrative and do not
        constitute an offer of credit.
      </p>
    </footer>
  );
}
